import * as React from 'react';
import classnames from 'classnames';
import { Icon } from '@grandvisionhq/icons';

const Item = ({ childMenuItems =[] , label , link , onItemClick , parameters , tabIndex , linkRef ,  })=>{
    const hasChildMenuItems = childMenuItems && childMenuItems.length > 0;
    const hasClickHandler = onItemClick && hasChildMenuItems;
    const handleClick = React.useCallback((event)=>{
        if (hasClickHandler) {
            event.preventDefault();
            onItemClick && onItemClick(label);
        }
    }, [
        hasClickHandler,
        label
    ]);
    const menuKey = parameters && parameters.menuKey || '';
    const classes = classnames('site-nav-mobile__item', {
        [`site-nav-mobile__item--${menuKey}`]: menuKey,
        'site-nav-mobile_is_active': link && link.active
    });
    return /*#__PURE__*/ React.createElement("li", {
        className: classes
    }, /*#__PURE__*/ React.createElement("a", {
        className: "site-nav-mobile__link",
        href: link === null || link === void 0 ? void 0 : link.href,
        target: (link === null || link === void 0 ? void 0 : link.openInNewWindow) ? '_blank' : '_self',
        onClick: handleClick,
        rel: "noreferrer",
        tabIndex: tabIndex,
        "aria-haspopup": !!hasChildMenuItems,
        ref: linkRef
    }, label), hasChildMenuItems && /*#__PURE__*/ React.createElement(Icon, {
        name: "chevron-right"
    }));
};

export { Item as default };
//# sourceMappingURL=Item.js.map
